<template>
  <component
    active-class="-active"
    exact-active-class="-active"
    :is="component"
    :to="!isExternal ? item.path : null"
    :href="item.path"
    :target="isExternal ? '_blank' : null"
    :disabled="item.disabled"
    :class="classes"
    @click="$emit('click')"
    @click.native="$emit('click')"
  >
    <c-icon
      v-if="item.icon"
      :icon="item.icon"
      class="icon"
      width="17"
      height="17"
    />

    <span class="name">{{ item.name }}</span>
  </component>
</template>

<script>
import isExternal from '@/helpers/isExternal'

export default {
  props: {
    isNuxt: Boolean,
    group: {
      type: String,
      default: 'primary'
    },
    item: {
      type: Object,
      required: true,
      validator ({ name, path }) {
        const isValid = name && path
        return isValid
      }
    }
  },
  computed: {
    classes () {
      const classes = [
        'c-menu-item',
        '-' + this.group,
        { '-disabled': this.item.disabled }
      ]
      return classes
    },
    isExternal () {
      const result = isExternal(this.item.path)
      return result
    },
    component () {
      const component = this.isExternal ? 'a'
        : this.isNuxt ? 'nuxt-link'
          : 'router-link'
      return component
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

// Item do menu
$c-menu-item-font-size: 11px !default;
$c-menu-item-font-weight: 500 !default;
$c-menu-item-font-family: $c-font-family-base !default;

// Item do menu com :hover
$c-menu-item-hover-name-color: #5e6684 !default;
$c-menu-item-hover-icon-color: #8c92b1 !default;

// Item do menu ativo
$c-menu-item-active-name-color: $c-color-primary !default;
$c-menu-item-active-icon-color: $c-color-primary !default;

.c-menu-item {
  text-decoration: none;
  cursor: pointer;

  & > .name {
    font-size: $c-menu-item-font-size;
    font-weight: $c-menu-item-font-weight;
    font-family: $c-menu-item-font-family;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0.5px;
    color: #8c92b1;
  }

  & > .icon {
    position: relative;
    margin-right: .625rem;
    bottom: -3px;
  }

  & > .icon > path {
    fill: #bec1d4;
    transition: fill 0.3s ease;
    will-change: fill;
  }

  &.-disabled { cursor: not-allowed; }

  &:hover {
    & > .name { color: $c-menu-item-hover-name-color; }
    & > .icon > path { fill: $c-menu-item-hover-icon-color; }
  }

  &.-active {
    & > .name { color: $c-menu-item-active-name-color; }
    & > .icon > path { fill: $c-menu-item-active-icon-color; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CMenuItem.vue